import React, {Fragment} from "react";
import logoKustomer from 'components/images/logos/logo_kustomer.svg'
import useKustomerSetup from "./useKustomerSetup";
import KustomerSetupModal from "./KustomerSetupModal";
import { useSelector } from "react-redux";
import ChannelCard from "../../Utilities/ChannelCard";
import DataSourceWebhookModal from "../../Utilities/DataSourceWebhookModal";

export default function KustomerProvider() {
	const kustomer = useSelector((state) => state.kustomerOauth)
	const { initiateKustomerSetup, kustomerSetupOpen, handleKustomerSetupOpen, handleKustomerSetupClose } = useKustomerSetup()

	return (
		<Fragment>
			<ChannelCard
				icon={logoKustomer}
				label={'Kustomer'}
				description={'Send personalized winback messages or resolve support tickets'}
				onClick={initiateKustomerSetup}
			/>

			<KustomerSetupModal
				open={kustomerSetupOpen}
				handleOpen={handleKustomerSetupOpen}
				handleClose={handleKustomerSetupClose}
			/>

			<DataSourceWebhookModal
				showWebhookUrl={kustomer?.showWebhookUrl}
				webhookUrl={kustomer?.data?.webhookUrl}
				platformUrl={kustomer?.data?.platformUrl}
				dataSourceName={'Kustomer'}
			/>
		</Fragment>
	)
}